import React from "react";
import "./HomeFeatureTab.css";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../../common/SectionTitle/SectionTitle";

export default function HomeFeatureTab({ imageSrc, title, tabSubtitle, tabTitle, description }) {
  return (
    <div className="home-feature-tab">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={6} lg={5}>
            <div className="home-feature-tab__media">
              <img src={imageSrc} alt={title} className="home-feature-tab__img" />
            </div>
          </Col>
          <Col md={6} lg={7}>
            <h3 className="home-feature-tab__title">{title}</h3>
            <p className="home-feature-tab__desc">{description}</p>

            <SectionTitle
              subtitle={tabSubtitle}
              title={tabTitle}
            />
          </Col>
        </Row>
      </Container>


      {/* <div className="home-feature-tab__content">

      </div> */}
    </div>
  );
}


